import MicrospecFlowCommonNavbar from "../MicrospecFlowCommonNavbar";

const MicrospecFlowCommonHeader = () => {
    return (
        <MicrospecFlowCommonNavbar />
    )
}

export default MicrospecFlowCommonHeader;